<script setup lang="ts">
import { useConfirm } from '@lib/composables/useConfirm'
import { useI18n } from 'vue-i18n'
import BBtn from '@lib/components/base/BBtn.vue'
import BDialog from '@lib/components/base/BDialog.vue'

const { current, _resolve } = useConfirm()
const { t } = useI18n()
</script>

<template>
    <BDialog
        :visible="current !== null"
        :title="current?.title ?? t('common.confirm.title')"
        :closable="false"
        @update:visible="
            v => {
                if (!v) _resolve(false)
            }
        "
    >
        <p v-if="current?.message" class="text-sm text-gray-700">{{ current.message }}</p>
        <template #footer>
            <BBtn
                severity="secondary"
                :label="current?.cancelLabel ?? t('common.actions.cancel')"
                @click="_resolve(false)"
            />
            <BBtn
                :severity="current?.severity === 'danger' ? 'danger' : 'primary'"
                :label="current?.confirmLabel ?? t('common.actions.confirm')"
                @click="_resolve(true)"
            />
        </template>
    </BDialog>
</template>
